"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPartnerProfilesProperty = exports.partnerProfilesPropertyDefinition = void 0;
exports.partnerProfilesPropertyDefinition = {
    view: {
        label: 'Partner profiles',
        hint: 'Want to co-brand this asset?',
    },
    constraints: [
        {
            name: 'stencils',
            argument: ['partner-profile'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'partner-profiles',
};
const isPartnerProfilesProperty = (prop) => {
    return prop.name === exports.partnerProfilesPropertyDefinition.name;
};
exports.isPartnerProfilesProperty = isPartnerProfilesProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFydG5lci1wcm9maWxlcy5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3BhcnRuZXItcHJvZmlsZXMucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQ0FBaUMsR0FBRztJQUMvQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUsa0JBQWtCO1FBQ3pCLElBQUksRUFBRSw4QkFBOEI7S0FDckM7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxVQUFVO1lBQ2hCLFFBQVEsRUFBRSxDQUFDLGlCQUFpQixDQUFDO1NBQzlCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGtCQUFrQjtDQUNPLENBQUE7QUFJMUIsTUFBTSx5QkFBeUIsR0FBRyxDQUFDLElBQWtCLEVBQW1DLEVBQUU7SUFDL0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHlDQUFpQyxDQUFDLElBQUksQ0FBQTtBQUM3RCxDQUFDLENBQUE7QUFGWSxRQUFBLHlCQUF5Qiw2QkFFckMifQ==